import { render } from "./Create.vue?vue&type=template&id=dc941e84&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "./Create.vue?vue&type=style&index=0&id=dc941e84&scoped=true&lang=less&rel=stylesheet%2Fless"

import exportComponent from "D:\\phpstudy_pro\\WWW\\guolang\\partner\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc941e84"]])

export default __exports__